<template>
    <!-- <FilterCompoennt :data="data" :notion="'https://www.notion.com/ko'" /> -->
    <FilterCompoennt :data="data"/>
    <BoardListDataComponent :data="data" :modalOpen="modalOpen" />
    <PaginationComponent :data="data" />
</template>

<script>
import BoardListDataComponent from '@/components/BoardListDataComponent.vue';
import FilterCompoennt from '@/components/FilterCompoennt.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';

export default {
    components: {
        FilterCompoennt,
        BoardListDataComponent,
        PaginationComponent,
    },
    props: {
        data: {},
        modalOpen: {},
    },
};
</script>
